import { useEffect, useRef } from 'react';
import { useVoiceRecorderStore } from './use-voice-store';

export const useVoiceRecorder = (
  onSendVoice: (file: File) => void,
  disabled: boolean = false
) => {
  const store = useVoiceRecorderStore();

  const prevOnSendVoice = useRef(onSendVoice);
  const prevDisabled = useRef(disabled);

  // useEffect(() => {
  //   if (prevOnSendVoice.current !== onSendVoice) {
  //     prevOnSendVoice.current = onSendVoice;
  //     store.setOnSendVoice(onSendVoice);
  //   }
  // }, [onSendVoice, store]);
  useEffect(() => {
    store.setOnSendVoice(onSendVoice);
  }, []);

  useEffect(() => {
    if (prevDisabled.current !== disabled) {
      prevDisabled.current = disabled;
      store.setDisabled(disabled);
    }
  }, [disabled, store]);

  const state = {
    recording: store.recording,
    recordTime: store.recordTime,
    voiceBlob: store.voiceBlob,
    recordingCanceled: store.recordingCanceled,
  };

  const actions = {
    startRecording: store.startRecording,
    stopRecording: store.stopRecording,
    cancelRecording: store.cancelRecording,
    resumeRecording: store.resumeRecording,
    sendVoice: store.sendVoice,
    reset: store.reset,
  };

  return [state, actions] as const;
};